import { axiosInstance } from "../../base/store/axios";
import constants from "./constants";

async function createDomain({ postData }) {
  const { data } = await axiosInstance.post(constants.POST_URL, postData);

  return data;
}
async function updateDomain({ patchData }) {
  const { data } = await axiosInstance.patch(
    `${constants.PATCH_URL}${patchData.id}/`,
    patchData
  );

  return data;
}

export { createDomain, updateDomain };
